import { useRef as r, useEffect as t } from "react";
function f(e) {
  const n = r(null);
  return t(() => {
    e && (typeof e == "function" ? e(n.current) : e.current = n.current);
  }), n;
}
export {
  f as useForwardedRef
};
